export default __webpack_public_path__ + "static/media/icona-calavera-gris.1fc25062.svg";